exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-05aaecbf] .accordion>.card:first-of-type{border:1px solid #e5e5e5;border-radius:2px}.accordion .card .card-header a[aria-expanded=true][data-v-05aaecbf]:before,[data-v-05aaecbf] .accordion .card .card-header a[aria-expanded=false]:before{color:#fff}", ""]);

// exports
